import { render } from "./readBookPage.vue?vue&type=template&id=e7b325c4&scoped=true"
import script from "./readBookPage.vue?vue&type=script&lang=js"
export * from "./readBookPage.vue?vue&type=script&lang=js"

import "./readBookPage.vue?vue&type=style&index=0&id=e7b325c4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7b325c4"]])

export default __exports__